import API, { API_URL } from "@/lib/api"

export const fetcher = async (url: string, init?: RequestInit) => {
  const res = await fetch(url, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...init?.headers,
    },
  })
  const data = await res.json()

  return data
}

export const apiFetcher = async (url: string, init?: RequestInit) => {
  return await API.request({
    method: init?.method,
    url: API_URL + url,
    data: init?.body,
    headers: {
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${session!.token}`,
    }
  }).then((res) => res.data)
}
